module.exports = __webpack_public_path__ + "fonts/Roboto-Light-94688f17.woff2";